<template>
  <div>
    <headerSection></headerSection>
    <div class="cashback-page">
      <!-- Hero Section -->
      <div class="cashback-hero">
        <div class="hero-bg-effects">
          <div class="floating-ball ball-1"></div>
          <div class="floating-ball ball-2"></div>
          <div class="floating-ball ball-3"></div>
        </div>
        <div class="container">
          <div class="hero-content">
            <div class="hero-icon">💎</div>
            <h1 class="hero-title">
              <span class="title-glow">{{ $t('cashback_page.title') }}</span>
            </h1>
            <p class="hero-description">
              {{ $t('cashback_page.hero_description') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="container cashback-content">
        <!-- Banner Section -->
        <div class="banner-section">
          <div class="banner-card">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/fun-beyond.firebasestorage.app/o/images%2F-Mz_m97zG-sNYbk4wxDC.png?alt=media&token=c30ff3b9-709e-40ac-8ac3-6d2cdc1bb66f"
              class="banner-image"
              alt="Cashback Banner"
            >
          </div>
        </div>

        <!-- Stats Section -->
        <div class="stats-section">
          <h3 class="section-title">
            <span class="title-icon">📊</span>
            {{ $t('cashback_page.title2') }}
          </h3>

          <div class="stats-grid">
            <!-- Deposit -->
            <div class="stat-card deposit">
              <div class="stat-icon-wrapper green">
                <span class="stat-icon">📥</span>
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ $t('deposit') }}</span>
                <span class="stat-value green">{{ numberWithCommas(cashback.deposit) }}</span>
              </div>
              <div class="stat-decoration">+</div>
            </div>

            <!-- Withdraw -->
            <div class="stat-card withdraw">
              <div class="stat-icon-wrapper red">
                <span class="stat-icon">📤</span>
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ $t('withdraw') }}</span>
                <span class="stat-value red">{{ numberWithCommas(cashback.withdraw) }}</span>
              </div>
              <div class="stat-decoration">-</div>
            </div>

            <!-- Total -->
            <div class="stat-card featured">
              <div class="stat-icon-wrapper gold">
                <span class="stat-icon">🏆</span>
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ $t('partner_title6') }}</span>
                <span class="stat-value gold">{{ numberWithCommas(cashback.total) }}</span>
              </div>
              <div class="stat-badge">฿</div>
              <div class="featured-glow"></div>
            </div>
          </div>
        </div>

        <!-- Transfer Button -->
        <div class="transfer-section">
          <button
            class="transfer-btn"
            :class="{ 'disabled': !cashback || !cashback.total || cashback.total <= 0 }"
            @click="moveCashbackToWallet()"
            :disabled="!cashback || !cashback.total || cashback.total <= 0"
          >
            <span class="transfer-icon">💳</span>
            <span class="transfer-text">{{ $t('partner_title7') }}</span>
            <span class="btn-shine"></span>
          </button>
        </div>

        <!-- Info Section -->
        <div class="info-section" v-if="detail">
          <div class="info-card">
            <div class="info-header">
              <span class="info-icon">💡</span>
              <span class="info-title">{{ $t('cashback_page.info_title') }}</span>
            </div>
            <div class="info-content" v-html="nl2br(detail)"></div>
          </div>
        </div>
      </div>
    </div>
    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'Cashback',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      cashback: [],
      detail: '',
      disabled: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    async waitForCashbackClaimResult (key, attempts = 10) {
      for (let attempt = 0; attempt < attempts; attempt++) {
        const snapshot = await firebase.firestore().collection('cashback').doc(key).get()
        const data = snapshot.exists ? (snapshot.data() || {}) : {}
        if (data.status === true) return { status: true, total: Number(data.total || 0) }
        if (data.blocked_reason || data.error) {
          return {
            status: false,
            code: data.blocked_reason || 'CASHBACK_CLAIM_BLOCKED',
            error: data.error || 'ไม่สามารถรับคืนยอดเสียได้ในขณะนี้'
          }
        }
        await new Promise(resolve => setTimeout(resolve, 500))
      }
      return {
        status: false,
        code: 'CASHBACK_CLAIM_TIMEOUT',
        error: 'ระบบกำลังตรวจสอบรายการ กรุณารอสักครู่แล้วลองใหม่อีกครั้ง'
      }
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    async moveCashbackToWallet () {
      if (this.cashback.total && this.cashback.key && !this.disabled) {
        this.disabled = true
        this.$store.commit('user/SET_LOADING', true)
        try {
          const claim = await axios.get(`https://api.funbeyond.cc/qcashback/cashback/${this.cashback.key}`)
          let result = claim && claim.data ? claim.data : {}
          if (result.status === undefined && result.id) {
            result = await this.waitForCashbackClaimResult(this.cashback.key)
          }
          if (!result.status) {
            this.$swal({ icon: 'error', title: 'ไม่สามารถรับคืนยอดเสียได้', text: result.error || 'กรุณาลองใหม่อีกครั้ง' })
            return
          }
          await this.getCashBack()
          this.$swal({ icon: 'success', title: 'รับคืนยอดเสียสำเร็จ', text: `เพิ่มเครดิต ${Number(result.total || 0).toLocaleString()} บาทแล้วค่ะ` })
        } catch (error) {
          const message = error && error.response && error.response.data && error.response.data.error
          this.$swal({ icon: 'error', title: 'ไม่สามารถรับคืนยอดเสียได้', text: message || 'กรุณาลองใหม่อีกครั้ง' })
        } finally {
          this.$store.commit('user/SET_LOADING', false)
          this.disabled = false
        }
      }
    },
    numberWithCommas (x) {
      if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
     nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    async getCashBack () {
      this.detail = (await firebase.database().ref('/cashback/detail').once('value')).val()
      const user = this.getUserId()
      if (user) {
        return firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.cashback = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.cashback = data
          })
        })
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getCashBack()
  }
}
</script>

<style scoped>
/* ============================================
   CASHBACK PAGE - MODERN DESIGN
   ============================================ */

.cashback-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1b1b41 0%, #492666 50%, #2b2727 100%);
  padding-bottom: 100px;
}

/* ============================================
   HERO SECTION
   ============================================ */

.cashback-hero {
  position: relative;
  padding: 40px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg,
    rgba(131, 9, 162, 0.1) 0%,
    transparent 100%
  );
}

.hero-bg-effects {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
}

.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #8309a2, #ffc107);
  top: -50px;
  left: -50px;
  animation: float1 6s ease-in-out infinite;
}

.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #fe8a02, #ffc107);
  top: 50%;
  right: -30px;
  animation: float2 8s ease-in-out infinite;
}

.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #492666, #8309a2);
  bottom: -20px;
  left: 30%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-20px, -30px) scale(1.1); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(20px, -20px); }
}

.hero-content {
  text-align: center;
  position: relative;
  z-index: 1;
}

.hero-icon {
  font-size: 60px;
  margin-bottom: 15px;
  animation: sparkle 2s ease-in-out infinite;
}

@keyframes sparkle {
  0%, 100% { transform: scale(1) rotate(0deg); filter: brightness(1); }
  50% { transform: scale(1.1) rotate(5deg); filter: brightness(1.2); }
}

.hero-title {
  margin: 0 0 15px;
}

.title-glow {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #ce93d8, #8309a2, #ce93d8);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: purpleShine 3s linear infinite;
}

@keyframes purpleShine {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}

.hero-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

/* ============================================
   CASHBACK CONTENT
   ============================================ */

.cashback-content {
  padding: 20px 15px;
}

/* ============================================
   BANNER SECTION
   ============================================ */

.banner-section {
  margin-bottom: 30px;
}

.banner-card {
  background: linear-gradient(135deg, rgba(131, 9, 162, 0.2), rgba(73, 38, 102, 0.15));
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 20px;
  padding: 20px;
  overflow: hidden;
  position: relative;
}

.banner-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(131, 9, 162, 0.1), transparent);
  transform: rotate(45deg);
  animation: shimmer 4s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%) rotate(45deg); }
  100% { transform: translateX(100%) rotate(45deg); }
}

.banner-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
  position: relative;
  z-index: 1;
}

/* ============================================
   STATS SECTION
   ============================================ */

.stats-section {
  margin-bottom: 30px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
}

.title-icon {
  font-size: 24px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.stat-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 20px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.stat-card.deposit {
  border-color: rgba(76, 175, 80, 0.3);
}

.stat-card.deposit:hover {
  border-color: rgba(76, 175, 80, 0.5);
}

.stat-card.withdraw {
  border-color: rgba(244, 67, 54, 0.3);
}

.stat-card.withdraw:hover {
  border-color: rgba(244, 67, 54, 0.5);
}

.stat-card.featured {
  grid-column: span 2;
  background: linear-gradient(135deg, rgba(131, 9, 162, 0.15), rgba(73, 38, 102, 0.1));
  border-color: rgba(131, 9, 162, 0.4);
}

.stat-icon-wrapper {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.stat-icon-wrapper.green {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(139, 195, 74, 0.1));
}

.stat-icon-wrapper.red {
  background: linear-gradient(135deg, rgba(244, 67, 54, 0.2), rgba(229, 115, 115, 0.1));
}

.stat-icon-wrapper.gold {
  background: linear-gradient(135deg, rgba(131, 9, 162, 0.2), rgba(255, 193, 7, 0.1));
}

.stat-icon {
  font-size: 24px;
}

.stat-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

.stat-value.green {
  color: #4caf50;
  text-shadow: 0 0 15px rgba(76, 175, 80, 0.5);
}

.stat-value.red {
  color: #f44336;
  text-shadow: 0 0 15px rgba(244, 67, 54, 0.5);
}

.stat-value.gold {
  color: #ffc107;
  text-shadow: 0 0 15px rgba(255, 193, 7, 0.5);
}

.stat-decoration {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 32px;
  font-weight: bold;
  opacity: 0.15;
  color: #fff;
}

.stat-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 28px;
  color: rgba(255, 193, 7, 0.3);
  font-weight: bold;
}

.featured-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100px;
  height: 100px;
  background: radial-gradient(circle, rgba(131, 9, 162, 0.2) 0%, transparent 70%);
  transform: translate(-50%, -50%);
  pointer-events: none;
}

/* ============================================
   TRANSFER SECTION
   ============================================ */

.transfer-section {
  margin-bottom: 30px;
}

.transfer-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 18px 32px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #8309a2 0%, #492666 100%);
  border: none;
  border-radius: 50px;
  cursor: pointer;
  overflow: hidden;
  box-shadow:
    0 4px 15px rgba(131, 9, 162, 0.4),
    0 0 30px rgba(131, 9, 162, 0.2);
  transition: all 0.3s ease;
}

.transfer-btn:hover:not(.disabled) {
  transform: translateY(-2px);
  box-shadow:
    0 6px 20px rgba(131, 9, 162, 0.5),
    0 0 40px rgba(131, 9, 162, 0.3);
}

.transfer-btn.disabled {
  background: linear-gradient(135deg, #555, #444);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
  box-shadow: none;
}

.transfer-icon {
  font-size: 24px;
}

.btn-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shine 3s ease-in-out infinite;
}

.transfer-btn.disabled .btn-shine {
  display: none;
}

@keyframes shine {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

/* ============================================
   INFO SECTION
   ============================================ */

.info-section {
  margin-bottom: 30px;
}

.info-card {
  padding: 25px;
  background: linear-gradient(135deg,
    rgba(131, 9, 162, 0.1) 0%,
    rgba(73, 38, 102, 0.05) 100%
  );
  border: 1px solid rgba(131, 9, 162, 0.3);
  border-radius: 20px;
}

.info-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.info-icon {
  font-size: 28px;
}

.info-title {
  font-size: 16px;
  font-weight: 600;
  color: #ce93d8;
}

.info-content {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.8;
  text-align: center;
}

/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 480px) {
  .hero-icon {
    font-size: 48px;
  }

  .title-glow {
    font-size: 24px;
  }

  .banner-card {
    padding: 15px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card.featured {
    grid-column: span 1;
  }

  .stat-value {
    font-size: 22px;
  }
}

@media (min-width: 769px) {
  .cashback-content {
    max-width: 600px;
    margin: 0 auto;
  }

  .title-glow {
    font-size: 32px;
  }
}
</style>
